// server/middleware/auth.ts handles token acquisition/refresh on the server side
// This middleware handles token refresh during client-side navigation
export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) return

  // Refer to useLogin.ts for the _auth_generation guard pattern
  const authGeneration = useState<number>('_auth_generation', () => 0)
  const gen = authGeneration.value

  const resolveUser = async () => {
    const ok = await useLogin().fetchUser()
    if (authGeneration.value !== gen) return

    if (!ok) {
      console.warn('Auth Middleware - fetchUser failed, obtaining guest tokens')
      const guestOk = await useGuestLogin().getAndSetGuestTokens()
      if (!guestOk) {
        console.error('Auth Middleware - failed to obtain guest tokens')
      }
    }
  }

  // With no tokens at all the outcome can only be a guest, so don't hold hydration on the SLAS
  // round trips. The layout stores still need the guest's customer id, so they wait on it.
  if (useNuxtApp().isHydrating && !isTokenValid() && !useCookie('refresh_token').value) {
    loadLayoutStoresAfter(resolveUser())
    return
  }

  await resolveUser()
})
